<template>
  <div class="big kefu_doctor">
    <ReturnVisit :isFlag="return_visit"
                 :businessId="patientId"
                 :visitType="visitType"
                 :visitName="visitName"
                 :activeIndexDia="activeIndexDia"
                 :sms_type="4"
                 :typeList="typeList"
                 @refreshList="getList"></ReturnVisit>
    <div class="page_title">患者记录</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="search-box">
          <div class="item">
            <span class="item_title">患者姓名</span>
            <el-input class="input_width"
                      v-model="real_name"
                      clearable
                      @change="search"></el-input>
          </div>
          <div class="item">
            <span class="item_title">用户昵称</span>
            <el-input v-model="nick_name"
                      clearable
                      class="input_width"
                      @change="search"></el-input>
          </div>
          <div class="item">
            <span class="item_title">客服标签</span>
            <el-select class="input_width"
                       v-model="label_id"
                       placeholder="请选择"
                       @change="search">
              <el-option label="全部"
                         value=''></el-option>
              <el-option v-for="item in visitLabel"
                         :key="item.label_id"
                         :label="item.label_name"
                         :value="item.label_id">
              </el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="item_title">是否已回访</span>
            <span>
              <el-radio-group v-model="is_visit"
                              @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
          </div>

          <template v-if="is_visit == 1">
            <div class="item">
              <span class="item_title">已回访类型</span>
              <el-select class="input_width"
                         v-model="visit_type"
                         placeholder="请选择"
                         clearable
                         @change="search">
                <el-option v-for="item in typeList"
                           :key="item.visit_type"
                           :label="item.value"
                           :value="item.visit_type">
                </el-option>
              </el-select>
            </div>

            <div class="item">
              <span class="item_title">已回访时间</span>
              <el-date-picker v-model="visit_time"
                              type="daterange"
                              range-separator="到"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间"
                              value-format="yyyy-MM-dd"
                              @change="search"
                              clearable></el-date-picker>
            </div>
          </template>
          <div class="item">
            <span class="item_title">性别</span>
            <span>
              <el-radio-group v-model="sex"
                              @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </span>
            <el-button type="primary"
                       style="margin-left:20px"
                       @click="getList"
                       size="medium">查询</el-button>
            <el-button @click="restBtn"
                       size="medium">重置</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-background="rgba(0, 0, 0,0.1)">
            <el-table-column label="患者姓名"
                             prop="real_name">
            </el-table-column>
            <el-table-column label="性别"
                             width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
              </template>
            </el-table-column>
            <el-table-column prop="age"
                             label="年龄"
                             width="60"></el-table-column>
            <el-table-column prop="phone"
                             label="手机号"></el-table-column>
            <el-table-column label="关系（是用户的）">
              <template slot-scope="scope">
                <span v-if="scope.row.relationship == 1">本人</span>
                <span v-if="scope.row.relationship == 2">爸爸</span>
                <span v-if="scope.row.relationship == 3">女</span>
                <span v-if="scope.row.relationship == 4">女</span>
                <span v-if="scope.row.relationship == 5">女</span>
                <span v-if="scope.row.relationship == 6">女</span>
                <span v-if="scope.row.relationship == 7">女</span>
                <span v-if="scope.row.relationship == 8">女</span>
                <span v-if="scope.row.relationship == 9">女</span>
              </template>
            </el-table-column>
            <el-table-column prop="nick_name"
                             label="用户昵称"></el-table-column>
            <el-table-column prop="phone"
                             label="用户手机号"></el-table-column>
            <el-table-column prop="customer_service_label"
                             label="客服标签"></el-table-column>
            <el-table-column label="是否已回访"
                             prop="is_return"
                             width="220px">
            </el-table-column>
            <el-table-column label="操作"
                             width="320">
              <template slot-scope="scope">
                <el-button @click="toReturn(scope.row.patient_id)"
                           type="text"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1315') : false
                ">回访</el-button>
                <el-button @click="toReturnList(scope.row.patient_id)"
                           type="text"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1308') : false
                ">回访记录</el-button>
                <el-button @click="editDia(scope.row)"
                           type="text"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('852') : false
                ">编辑客服标签</el-button>
                <!-- <el-button @click="setIsReturn(scope.row.patient_id)"
                           type="text"
                           v-if="scope.row.is_return == 0&&laber_code!='patient_0'"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1307') : false
                ">标记为已回访</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="pagesize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin-top:20px"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑标签 -->
    <el-dialog title="编辑客服标签"
               :visible.sync="tagDia"
               width="500px"
               :close-on-click-modal="false">
      <div class="diabox">
        <el-checkbox-group v-model="labelData.label"
                           size="medium">
          <div class="checkbox">
            <el-checkbox v-for="(item,index) in visitLabel"
                         :key="index"
                         :label="item.label_name"
                         border></el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="tagDia=false"
                   size="medium">取 消</el-button>
        <el-button type="primary"
                   @click="setPatientLabel"
                   size="medium"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('850') : false ">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReturnVisit from '../../../components/common/ReturnVisit.vue';
export default {
  components: {
    ReturnVisit
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      real_name: '',
      nick_name: '',
      label_id: '',
      // laber_code: 'patient_0',
      is_visit: '',
      visit_type: '',
      visit_time: [],
      sex: '',
      loading: false,
      tableData: [],
      tagDia: false,
      visitLabel: [],
      typeList: [],
      labelData: {
        patient_id: '',
        label: []
      },
      return_visit: false,
      patientId: 0,
      visitName: 'patient',
      visitType: 2,
      activeIndexDia: '1'
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getVisitType();
    this.getVisitLabel();
  },
  methods: {
    //获取回访类型
    getVisitType() {
      this.axios
        .post('platform/Clientreview/getVisitType', { visit_type: 'patient' })
        .then((res) => {
          if (res.code == 0) {
            this.typeList = res.data.list;
            // this.laber_code = res.data.laber_code;
            this.getList();
          }
        });
    },
    // 获取回访标签
    getVisitLabel() {
      this.axios
        .post('platform/Admin/getLabel', {
          type: 1,
          label_type: 1
        })
        .then((res) => {
          if (res.code == 0) {
            this.visitLabel = res.data.list;
          }
        });
    },
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        real_name: this.real_name,
        nick_name: this.nick_name,
        label_id: this.label_id,
        // laber_code: this.laber_code,
        is_visit: this.is_visit,
        sex: this.sex
      };
      if (this.is_visit == 1) {
        data.visit_start_time = this.visit_time ? this.visit_time[0] : '';
        data.visit_end_time = this.visit_time ? this.visit_time[1] : '';
        data.visit_type = this.visit_type;
      }
      this.axios
        .post('platform/Clientreview/patientList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //编辑标签弹窗
    editDia(row) {
      this.labelData = {
        patient_id: row.patient_id,
        label: row.customer_service_label
          ? row.customer_service_label.split(',')
          : []
      };
      this.tagDia = true;
    },
    //编辑客服标签
    setPatientLabel() {
      let id_arr = [];
      this.labelData.label.map((item) => {
        let data = this.visitLabel.find((ele) => {
          return ele.label_name == item;
        });
        if (data) {
          id_arr.push(data.label_id);
        }
      });
      let data = {
        patient_id: this.labelData.patient_id,
        customer_service_label: this.labelData.label.toString(),
        label_id: id_arr.toString()
      };
      this.axios
        .post('platform/Clientreview/setPatientServiceLabel', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.tagDia = false;
          }
          this.getList();
        });
    },
    restBtn() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.real_name = '';
      this.nick_name = '';
      this.label_id = '';
      // this.laber_code = 'patient_0';
      this.is_visit = '';
      this.sex = '';
      this.getList();
    },
    //设置标记已回访
    setIsReturn(patient_id) {
      let data = {
        laber_code: this.laber_code,
        visit_type: 'patient',
        visit_type_id: patient_id
      };
      this.axios.post('platform/Clientreview/setIsReturn', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('已标记为已回访');
        }
        this.getList();
      });
    },
    //回访
    toReturn(patient_id) {
      this.patientId = patient_id;
      this.activeIndexDia = '1';
      this.return_visit = !this.return_visit;
    },
    //回访记录
    toReturnList(patient_id) {
      this.patientId = patient_id;
      this.activeIndexDia = '2';
      this.return_visit = !this.return_visit;
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.search-box {
  display: flex;
  flex-wrap: wrap;
  .input_width {
    width: 180px;
  }
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .item_title {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      text-align: right;
      box-sizing: border-box;
    }
  }
}
.diabox {
  padding: 20px;
}
.checkbox {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
}
</style>
<style>
.kefu_doctor .el-checkbox {
  margin: 0 20px 10px 0 !important;
}
</style>